import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import Button from "../components/Button"
import { LinkButton } from "../components/Button"
import NewsCard from "../components/Cards/News"
import Layout from "../components/Layout"
import SEO from "../components/seo"
import { graphql } from "gatsby"
import { map } from "lodash"
import Img from "gatsby-image"
import "../styles/dark-mode.scss"

export default ({
  pageContext: {
    pageInfo: { sectionTitle, cta },
    news,
    item: {
      published,
      title,
      link,
      source,
      imageDetail,
      imageAlt = "Missing Alt Text",
      description,
    },
  },
}) => (
  <Layout fluid={true} pageInfo={{ pageName: "FP News Detail" }}>
    <SEO title={title} keywords={[`news`, `detail`]} />
    <Container className={"mt-sm-0 featured-area"} fluid>
      <Container className={"section-padding"}>
        <Row className={"pb-4"}>
          <Col>
            <Button
              to={`/first-responders/news/`}
              icon={`arrow-left`}
              className={`back btn btn-red-outline`}
              variant={`red-outline`}
              label={cta}
            />
          </Col>
        </Row>
        <Row>
          <Col
            md={10}
            lg={5}
            className={"pt-md-4 order-2 order-lg-1 offset-lg-0 offset-md-1"}
          >
            <p>{published}</p>
            <h1 className={"pb-3"}>{title}</h1>
            <div className="flex-mobile-reverse">
              <LinkButton className="w-100 my-4" label={source} link={link} />
              <p>{description}</p>
            </div>
          </Col>
          <Col md={12} lg={7} className={"order-lg-2 order-1 mb-4"}>
            <Img
              className={"rounded news-detail-aspect-ratio"}
              key={`img-detail-${imageDetail.childImageSharp.fixed.originalName}`}
              loading={"lazy"}
              fixed={imageDetail.childImageSharp.fixed}
              alt={imageAlt}
            />
          </Col>
        </Row>
      </Container>
    </Container>
    <Container className={"explore story-cards explore-section"} fluid>
      <Container>
        <Row className={"pl-3 pb-3"}>
          <h2>{sectionTitle}</h2>
        </Row>
        <Row>
          {map(news, (item, i) => (
            <Col
              className={i >= 2 ? "mb-4 d-none d-md-none d-lg-block" : "mb-4"}
              md={6}
              lg={4}
              key={"story-col-" + i}
            >
              <NewsCard fp={true} key={"story-card-" + i} {...item} />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  </Layout>
)

export const SinglePostQuery = graphql`
  query FPNewsDetailQuery {
    pageInfo: pagesYaml(slug: { eq: "fp-news-detail" }) {
      cta
      sectionTitle
    }
    news: allNewsYaml(sort: { order: DESC, fields: published }, limit: 3) {
      nodes {
        title
        description
        published(formatString: "MMMM D, YYYY")
        source
        link
        slug
        imageFeatured {
          childImageSharp {
            fixed(width: 1108, height: 444) {
              width
              height
              src
              srcSet
              aspectRatio
              originalName
            }
          }
        }
        imageThumb {
          childImageSharp {
            fixed {
              width
              height
              originalName
              src
              srcSet
            }
          }
        }
        imageAlt
      }
    }
  }
`
